import Box from '@mui/material/Box';

import { EMPTY_STRING } from '@e-socna/empty';

import { environment } from '../../../../environment';

import { LimitedFeature } from '../../../LimitedFeature';
import { DisabledFeatureInStrictMode } from '../../../DisabledFeatureInStrictMode';
import { PdfViewer } from '../../../PdfViewer';

import { getPreviewableKind } from './utils/get-previewable-kind.util';
import type { FileItem } from './types/file-item.type';

interface Props {
  readonly file: FileItem;
  readonly useCompressedVersion?: boolean;
}

export const FilePreviewContent = ({
  file,
  useCompressedVersion = false,
}: Readonly<Props>) => {
  const kind = getPreviewableKind(file.mimeType);
  const url = `${environment.backendUrl}/${file.uri}${useCompressedVersion ? '?compressed=true' : EMPTY_STRING}`;

  if (kind === 'pdf') {
    return (
      <DisabledFeatureInStrictMode>
        <PdfViewer showControls url={url} />
      </DisabledFeatureInStrictMode>
    );
  }

  if (kind === 'image') {
    return (
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexGrow: 1,
          justifyContent: 'center',
        }}
      >
        <Box
          alt={file.originalName}
          component="img"
          src={url}
          sx={{ maxHeight: '100%', maxWidth: '100%' }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center',
      }}
    >
      <LimitedFeature wish="pouvoir consulter les fichiers de ce format" />
    </Box>
  );
};
